import { Box, InputAdornment, TextField } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import type { ReactNode, Ref } from "react";

/** Search (and filters) on the left, the page's buttons on the right. */
export default function ListToolbar({
  search,
  onSearch,
  placeholder,
  filters,
  actions,
  inputRef,
}: {
  search: string;
  onSearch: (value: string) => void;
  placeholder: string;
  filters?: ReactNode;
  actions?: ReactNode;
  /** Focus lands here when a selection bar that stood in its place goes. */
  inputRef?: Ref<HTMLInputElement>;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.5,
        p: { xs: 1.5, sm: 2 },
        flexShrink: 0,
      }}
    >
      <TextField
        size="small"
        value={search}
        onChange={(event) => onSearch(event.target.value)}
        placeholder={placeholder}
        inputRef={inputRef}
        inputProps={{ "aria-label": placeholder }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlined fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{ width: { xs: "100%", sm: 300 } }}
      />
      {filters}
      {actions ? (
        <Box
          sx={{
            ml: { sm: "auto" },
            display: "flex",
            gap: 1.5,
            flexWrap: "wrap",
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
